@let title = titleText() ?? (titleKey() | translate);
<button
  type="button"
  class="nav-tile"
  [attr.data-testid]="testId()"
  [attr.aria-label]="'home.tiles.open' | translate: { title }"
  (click)="open()"
>
  <span class="nav-tile__badge">
    <mat-icon aria-hidden="true">{{ icon() }}</mat-icon>
  </span>
  <span class="nav-tile__content">
    <span class="nav-tile__title">{{ title }}</span>
    <span class="nav-tile__subtitle">{{ subtitleKey() | translate }}</span>
    @if (stats().length) {
      <span class="nav-tile__stats">
        @for (stat of stats(); track stat.labelKey) {
          <span class="nav-tile__stat">
            <span class="nav-tile__stat-label">{{ stat.labelKey | translate }}</span>
            <span class="nav-tile__stat-value">{{ stat.value }}</span>
          </span>
        }
      </span>
    }
  </span>
  <mat-icon class="nav-tile__chevron" aria-hidden="true">chevron_right</mat-icon>
</button>
